export default "__VITE_ASSET__C3PzCow2__"